import { Page, PageHeader } from '../../components/layout/page';
import React from 'react';
import { usePaymentList } from './states/PaymentListState';
import { PaneSubHeader } from '../../../mainv3/components/molecules/mypage/page';
import { LoaderRow } from '../../../mainv3/components/atoms/layout/LoaderRow';
import { PaymentView } from '../../../mainv3/components/organisms/mypage/PaymentView';
import { CurrentCardSummary } from '../../../mainv3/components/organisms/payments/CurrentCardSummary';
import { CurrentCardPlaceholder } from '../../../mainv3/components/organisms/payments/CurrentCardPlaceholder';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { AccountRoutes } from '../../routes/AccountRoutes';

export const PaymentListPage = observer(() => {
  const state = usePaymentList();
  const { cardSummaryResource, paymentsResource, loading } = state;
  const cardSummary = cardSummaryResource.get();
  const payments = paymentsResource.getOrElse([]);
  return (
    <Page id="payment-list-page">
      <PageHeader>お支払い情報 / 履歴</PageHeader>
      {loading && <LoaderRow />}
      {cardSummary && (
        <CurrentCardSummary
          cardSummary={cardSummary}
          onRequestUpdate={() => GlobalStatesV3.routing.push(AccountRoutes.paymentInfo())}
        />
      )}
      {!cardSummary && (
        <CurrentCardPlaceholder onRequestCreate={() => GlobalStatesV3.routing.push(AccountRoutes.paymentInfo())} />
      )}
      <PaneSubHeader>お支払い履歴</PaneSubHeader>
      {loading && <LoaderRow />}
      {payments.map((payment, i) => (
        <PaymentView payment={payment} showAction={false} key={i} />
      ))}
    </Page>
  );
});
